import { useXStateForm } from "@/hooks/useXStateForm";
import { createActorContext } from "@xstate/react";
import React from "react";

type XstateFormProps = {
  children: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  machineContext: ReturnType<typeof createActorContext<any>>;
  successToast?: string;
};

export const XstateForm: React.FC<XstateFormProps> = ({
  children,
  machineContext,
  successToast
}) => {
  useXStateForm({ machineContext, successToast });

  return <>{children}</>;
};
